"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "avezzano": {
    "4eb7070f": [{
      "hkey": "5e2ed2b8",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "caruscino": [{
      "hkey": "5e2ed2b8",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "avezzano"
    }],
    "4db480db": [{
      "hkey": "56207d98",
      "slug": "paterno-san-pelino",
      "name": "Paterno-San Pelino",
      "primary": true,
      "skipSearch": false
    }],
    "paterno": [{
      "hkey": "56207d98",
      "slug": "paterno-san-pelino",
      "name": "Paterno-San Pelino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "3fd400c1": [{
      "hkey": "56207d98",
      "slug": "paterno-san-pelino",
      "name": "Paterno-San Pelino",
      "primary": true,
      "skipSearch": false
    }],
    "san-pelino": [{
      "hkey": "56207d98",
      "slug": "paterno-san-pelino",
      "name": "Paterno-San Pelino",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "avezzano"
    }],
    "b0c83435": [{
      "hkey": "183d0e38",
      "slug": "borgo-via-nuova",
      "name": "Borgo Via Nuova",
      "primary": true,
      "skipSearch": false
    }],
    "via-nuova": [{
      "hkey": "183d0e38",
      "slug": "borgo-via-nuova",
      "name": "Borgo Via Nuova",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;